import { Trans, useTranslation } from "react-i18next";
import { EmptyPanel } from "components/empty/EmptyPanel";
import { Icon } from "components/icon/Icon";
import { BasePanel } from "components/BasePanel";

export interface SalesDataEmptyStateProps {
  bookTitle: string;
}

export const SalesDataEmptyState = ({
  bookTitle,
}: SalesDataEmptyStateProps) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <BasePanel
      isEmpty
      emptyComponent={
        <EmptyPanel
          image={
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-secondary-100">
              <Icon
                name="chart-column-increasing"
                size="large"
                iconClassName="text-secondary-400"
              />
            </div>
          }
          title={t("productDetails:salesData.empty.title")}
          text={
            <Trans
              i18nKey="productDetails:salesData.empty.text"
              values={{ title: bookTitle }}
              components={{
                bookTitle: (
                  <strong className="font-semibold text-secondary-700" />
                ),
              }}
            />
          }
          classes={{
            text: "max-w-xl pt-2",
            container: "bg-gray-50",
          }}
        />
      }
    />
  );
};
